export default __webpack_public_path__ + "static/media/feeling.3ff15635.png";